import React from 'react';
import { Button, Typography } from '@mui/material';
import { EventBus } from '@/shared/utils';
import { AuthEventKeys, AuthEvents } from '../events';
import Confirm from './confirm';
import { Auth } from '@/shared/i18n';

type NewPasswordOkProps = {
  eventBus: EventBus<AuthEvents>;
  dict: Auth;
};

function NewPasswordOk({ eventBus, dict }: NewPasswordOkProps) {
  const handleBackToLogin = () => {
    eventBus.emit(AuthEventKeys.login.go, undefined);
  };

  return (
    <section className="flex z-10 flex-col self-center max-w-[600px] px-6 py-8 md:px-16 md:py-12 rounded-xl bg-paper">
      <Confirm
        imgSrc="/assets/images/success-green.svg"
        title={dict.new_password?.success_title || 'Password Resettata'}
        mailfield={false}
        description={
          dict.new_password?.success_description ||
          'La tua password è stata resettata con successo. Puoi ora accedere con la nuova password.'
        }
        footer={
          <div className="flex flex-col w-full mt-8">
            <Button
              size="large"
              variant="contained"
              color="primary"
              className="w-full max-md:max-w-full"
              onClick={handleBackToLogin}
            >
              <Typography variant="button-l">
                {dict.new_password?.back_to_login || 'Torna al login'}
              </Typography>
            </Button>
          </div>
        }
      />
    </section>
  );
}

export default NewPasswordOk;
